export default __webpack_public_path__ + "static/articlePageHeader-4a819f93013501497a221c8038460df5.png";